interface ISpAuthorizationToken {
    getAuthorizationTokenForEvent: (
        forceRefresh?: boolean,
        request?: { albumId?: number | string }
    ) => Promise<string>;
}

let authorizationTokenService: ISpAuthorizationToken | null = null;

export const setAuthorizationTokenService = (service: ISpAuthorizationToken): void => {
    authorizationTokenService = service;
};

export const getAuthorizationTokenForEvent = (
    forceRefresh = false,
    request?: { albumId?: number | string }
): Promise<string> => {
    if (!authorizationTokenService) {
        return Promise.reject(new Error('Auth service not initialized'));
    }

    return authorizationTokenService.getAuthorizationTokenForEvent(forceRefresh, request);
};
